export const SearchQuery = `
query ListSpaces($query: String!, $siteAri: String!, $entityAti: String!, $confluenceSpaces: [String!]) {
	search {
		search(
			query: $query
			filters: {
				entities: [$entityAti],
				locations: [$siteAri],
				confluenceFilters: {
					spacesFilter: $confluenceSpaces
				}
			}
			experience: "rovo-chat"
		) {
			edges {
				node {
					ari: id
					displayName: title
					iconUrl
					url
					... on SearchConfluenceSpace {
						spaceKey: key
					}
				}
			}
		}
	}
}
`;

export const JiraProjectsQuery = `
query GetProjects($aris: [ID!]!) {
  jira {
    jiraProjects(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: avatar {
        small
      }
			url: webUrl
    }
  }
}
`;

export const ConfluencePagesQuery = `
query GetPages($aris: [ID!]!) {
  confluence {
    pages(
      ids: $aris
    ) {
      ari: id
      displayName: title
			links {
        base
        webUi
      }
    }
  }
}
`;

export const GetSpacesQuery = `
query GetSpaces($aris: [ID!]!) {
  confluence {
    spaces(
      ids: $aris
    ) {
      ari: id
      displayName: name
      iconUrl: icon {
        path
      }
			spaceKey: key
			links {
        base
        webUi
      }
    }
  }
}
`;
